var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVerificationFailed = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 72,
  height: 72,
  viewBox: "0 0 72 72",
  fill: "none",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 72,
  height: 72,
  fill: "#FFFFFF",
  rx: 36
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(36, 36) scale(1.35) translate(-12, -12)",
  fill: "none",
  stroke: "#3b82f6",
  strokeWidth: 1.7,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 3.2 5 5.8v5.4c0 4.2 2.8 7.6 7 9.6 4.2-2 7-5.4 7-9.6V5.8L12 3.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 8.6v4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 15.6h.01"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgVerificationFailed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/verification_failed.8b3f012f22526724542b7eced31c05ba.svg";